import React from "react";
import Modal from "../Modal";
import PropTypes from "prop-types";
import BtnBlanc from "Components/Boutons/BtnBlanc/btn-blanc";
import "./ModalAuthentificationEntreprise.scss";
import ConnexionEntrepriseForm from "./Forms/ConnexionEntrepriseForm/ConnexionEntrepriseForm";
import InscriptionEntrepriseForm from "./Forms/InscriptionEntrepriseForm/InscriptionEntrepriseForm";

/**
 * Composant 'ModalAuthentificationEntreprise'
 *
 * Affiche le modal d'authentification pour les recruteurs, permet de se connecter ou de s'inscrire.
 *
 * En cas de connexion réussie, l'utilisateur est redirigé sur le portail recruteur, avec un token d'authentification.
 *
 * Un bouton oublie de mot de passe est présent, il permet de renvoyer un mail de réinitialisation de mot de passe.
 *
 * @param {boolean} authEntrepriseVisible - Indique si le modal est visible
 * @param {function} setAuthEntrepriseVisible - Permet de changer la valeur de authEntrepriseVisible
 * @param {string} authState - Indique l'état du modal (default, login, register)
 */
const ModalAuthentificationEntreprise = (props) => {
  const [authState, setAuthState] = React.useState("default");

  React.useMemo(() => {
    if (props.authState) setAuthState(props.authState);
  }, [props.authState]);

  return (
    <React.Fragment>
      <Modal
        blockScroll
        visible={props.authEntrepriseVisible}
        setVisible={props.setAuthEntrepriseVisible}
        header="Authentification Recruteur"
        className="modal modal__entreprise"
        width={authState === "default" ? "30vw" : "40vw"}
        key={authState}
      >
        {authState === "default" && (
          <div className="modal__entreprise__buttons">
            <BtnBlanc
              btnTexte="Se connecter"
              btnAction={() => setAuthState("login")}
            />
            <BtnBlanc
              btnTexte="S'inscrire"
              btnAction={() => setAuthState("register")}
            />
          </div>
        )}
        {authState === "login" && (
          <div className="modal__entreprise__login">
            <ConnexionEntrepriseForm setAuthState={setAuthState} />
          </div>
        )}

        {authState === "register" && (
          <div className="modal__entreprise__register">
            <InscriptionEntrepriseForm
              setAuthEntrepriseVisible={props.setAuthEntrepriseVisible}
            />
          </div>
        )}
      </Modal>
    </React.Fragment>
  );
};

ModalAuthentificationEntreprise.propTypes = {
  authEntrepriseVisible: PropTypes.bool.isRequired,
  setAuthEntrepriseVisible: PropTypes.func.isRequired,
  authState: PropTypes.string.isRequired,
};

ModalAuthentificationEntreprise.defaultProps = {
  authState: "default",
};

export default ModalAuthentificationEntreprise;
